import { createSlice } from '@reduxjs/toolkit'

export const StepsReducer = createSlice({
    name: 'steps',
    initialState: {
        stepsData: false,
    },
    reducers: {
        setStepsData: (state, action) => { state.stepsData = action.payload },
    },
})

// Action creators are generated for each case reducer function
export const { setStepsData } = StepsReducer.actions

export default StepsReducer.reducer